import React from "react";

const AutoreleaseDisclaimer = () => (
  <p className="text-xs italic text-gray-500 leading-relaxed">
    Autorelease is only offered when your last approved and submitted responses
    are less than 1 year old and the Diligent VQQ template has not been updated
    since they were last approved and submitted.
  </p>
);

export default AutoreleaseDisclaimer;
